/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Grid_Not_InitializedInputs */



/**
* | output |
* | --- |
* | "Grid not initialized" |
*
* @param {Knp_Terms_Grid_Not_InitializedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_grid_not_initialized = /** @type {((inputs?: Knp_Terms_Grid_Not_InitializedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Grid_Not_InitializedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Grille non initialisée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Grid nicht initialisiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Griglia non inizializzata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сетка не инициализирована")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cuadrícula no inicializada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("网格未初始化")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グリッドが初期化されていません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ग्रिड आरंभ नहीं हुआ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grade não inicializada")
	return /** @type {LocalizedString} */ ("Grid not initialized")
});